class ReadMore extends HTMLElement {
    constructor() {
        super();

        // this.initialText = this.querySelector('.js-read-more--initial-text');
        this.toggleButton = this.querySelector('.trigger');
        this.contentElement = this.querySelector('.js-read-more .js-read-more--text');

        // If set false in the html, the read less is disabled
        this.enableReadLess = this.getAttribute('enable-read-less');
        // In the html set a number of characters to create the substring
        this.listener();
    }

    // cutText() {
    //     this.longContent = this.contentElement.textContent;
    //     if (!this.charactersSubstring) {
    //         this.charactersSubstring = 90;
    //     }
    //     this.shortContent = `${this.longContent.substring(0, this.charactersSubstring)}...`;

    //     this.contentElement.innerHTML = this.shortContent;
    //     this.contentElement.appendChild(this.toggleButton);
    //     this.setAttribute('data-content', 'short');
    //     this.classList.remove('tw-opacity-0');
    // }

    connectedCallback() {
        this.checkHeight();
    }
    checkHeight() {
        if (this.contentElement.scrollHeight > this.contentElement.clientHeight) {
            this.toggleButton.classList.remove('tw-hidden');
        }
    }

    listener() {
        this.toggleButton.addEventListener("click", () => {
            this.toggleText();
        });
        this.toggleButton.addEventListener("keydown", (e) => {
            if(e.keyCode == ENTER_KEY_CODE){
                this.toggleText();
            }
        });
    }

    toggleText() {
        // if (this.classList.contains('tw-initial-read-more')) {
        //   this.classList.remove('tw-initial-read-more');
        // }
        if (this.dataset.content == 'long') {
            this.contentElement.classList.add("tw-line-clamp-1");
            this.contentElement.closest(".content").style.marginBottom = ".4rem";
            this.toggleButton.querySelector("span").innerText = this.toggleButton.getAttribute('text-more');
            this.setAttribute('data-content', 'short');
        }
        else {
            this.contentElement.classList.remove("tw-line-clamp-1");
            this.contentElement.closest(".content").style.marginBottom = "1.4rem";
            if (this.enableReadLess != "false") {
                //this.contentElement.appendChild(this.toggleButton);
                this.toggleButton.querySelector("span").innerText = this.toggleButton.getAttribute('text-less');
            }
            this.setAttribute('data-content', 'long');
        }
    }

}

customElements.define('read-more', ReadMore);